import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, reverse } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moStaffTrend = observable({
  type: 'chart', // chart, table
  empty: false,
  tableTitle: <any[]>[],
  tableList: <any[]>[],

  adminX: <any[]>[],
  adminY: <any[]>[],
  financeX: <any[]>[],
  financeY: <any[]>[],
  produceX: <any[]>[],
  produceY: <any[]>[],
  saleX: <any[]>[],
  saleY: <any[]>[],
  techX: <any[]>[],
  techY: <any[]>[],
  overview: <any[]>[],
});

const staffTrendInit = action((res: any) => {
  // console.log('人员配置 员工构成时间趋势 -- ', res);
  if (isEmpty(res)) {
    moStaffTrend.empty = true;
    return;
  }
  if (isEmpty(res.admin) && isEmpty(res.finance) && isEmpty(res.tech) && isEmpty(res.sale) && isEmpty(res.produce)) {
    moStaffTrend.empty = true;
    return;
  }
  moStaffTrend.empty = false;
  const adminX: any[] = [];
  const adminY: any[] = [];
  const financeX: any[] = [];
  const financeY: any[] = [];
  const produceX: any[] = [];
  const produceY: any[] = [];
  const saleX: any[] = [];
  const saleY: any[] = [];
  const techX: any[] = [];
  const techY: any[] = [];
  const tableArr: any[] = [];
  const yearArr: any[] = [];

  res?.admin?.map((item: any) => {
    adminX.push(item.value);
    adminY.push(item.year);
    yearArr.push(item.year);
  });
  res?.finance?.map((item: any) => {
    financeX.push(item.value);
    financeY.push(item.year);
  });
  res?.tech?.map((item: any) => {
    techX.push(item.value);
    techY.push(item.year);
  });
  res?.sale?.map((item: any) => {
    saleX.push(item.value);
    saleY.push(item.year);
  });
  res?.produce?.map((item: any) => {
    produceX.push(item.value);
    produceY.push(item.year);
  });

  for (let i = 0; i < yearArr.length; i += 1) {
    tableArr.push([yearArr[i]]);
  }
  tableArr.map((item: any) => {
    res?.produce?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.tech?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.sale?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.finance?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.admin?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  // console.log('table arr -- ', tableArr);

  runInAction(() => {
    moStaffTrend.adminX = reverse(adminX);
    moStaffTrend.adminY = reverse(adminY);
    moStaffTrend.financeX = reverse(financeX);
    moStaffTrend.financeY = reverse(financeY);
    moStaffTrend.produceX = reverse(produceX);
    moStaffTrend.produceY = reverse(produceY);
    moStaffTrend.saleX = reverse(saleX);
    moStaffTrend.saleY = reverse(saleY);
    moStaffTrend.techX = reverse(techX);
    moStaffTrend.techY = reverse(techY);
    moStaffTrend.overview = res.overview;
    moStaffTrend.tableTitle = ['年份', '生产/工程人员', '技术人员占比', '销售人员占比', '财务人员占比', '行政人员占比'];
    moStaffTrend.tableList = tableArr;
  });
});

const changeType = action((value: string) => {
  moStaffTrend.type = value;
  localStorage.setItem('settleStaffTrendType', value);
});

export default moStaffTrend;
export {
  staffTrendInit, changeType,
};
